<div class="view-transaction-dialog" *ngIf="(bankTransactionsService.transactionDetailsObservable$| async)">
  <div class="view-transaction-header">
    <div class="view-transaction-txt">Transaction details</div>
    <button class="close-button"
      (click)="bankTransactionsService.closeDrawer()"
      (keydown)="bankTransactionsService.closeDrawer()">
      <img src="../../../assets/images/cross_icon_grey.svg" alt="close" height="24px" width="24px">
    </button>
  </div>
  <div class="view-transaction-body">
    <div class="details-box">
      <div class="details-header">
        <button class="icon-circle">
          <img src="../../../../assets/images/transactions_icon_white.svg" height="17px" width="17px" alt="sync" />
        </button>
        <span class="view-transaction-txt">Basic details</span>
      </div>
      <div class="details-box-body">
        <p *ngIf="bankTransactionsService.transactionDetailsObservable$| async as tx">
          <span class="key">Bank Account</span>
          <span class="value bank-name">{{tx.bankName || '-'}} / {{tx.iban || '-'}}</span>
        </p>
        <p *ngIf="bankTransactionsService.transactionDetailsObservable$ | async as tx">
          <span class="key">Date</span>
          <span class="value">{{commonService.formateDate(tx.executionDate) || '-'}}</span>
        </p>
        <p *ngIf="bankTransactionsService.transactionDetailsObservable$ | async as tx">
          <span class="key">Transaction Code</span>
          <span class="value">{{tx.bankTransactionCode || '-'}}</span>
        </p>
        <p *ngIf="bankTransactionsService.transactionDetailsObservable$ | async as tx">
          <span class="key">Transaction Type</span>
          <span class="value">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <circle cx="6" cy="6" r="6" [attr.fill]="tx.amount < 0 ? '#fa5430' : '#81BD2E'" style="margin-right: 8px;" />
            </svg>
            {{ tx.amount < 0 ? 'Outgoing' : 'Incoming' }}
          </span>
        </p>
        <p>
          <span class="key">Currency</span>
          <span class="value">{{(bankTransactionsService.transactionDetailsObservable$| async)?.currency || '-'}}</span>
        </p>
        <p>
          <span class="key">Amount</span>
          <span class="value">{{(((bankTransactionsService.transactionDetailsObservable$| async)?.amount)| number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') + ' €'}}</span>
        </p>
        <p>
          <span class="key">Purpose</span>
          <span class="value" style="margin-left: 20px;">{{(bankTransactionsService.transactionDetailsObservable$| async)?.description || '-'}}</span>
        </p>
        <p>
          <span class="key">Additional Info</span>
          <span class="value" style="margin-left: 20px;">{{(bankTransactionsService.transactionDetailsObservable$| async)?.additionalInformation || '-'}}</span>
        </p>
      </div>
    </div>
    <div class="details-box">
      <div class="details-header">
        <button class="icon-circle">
          <img src="../../../../assets/images/user_icon_white.svg" height="20px" width="20px" alt="sync" />
        </button>
        <span class="view-transaction-txt">Counterparty Details</span>
      </div>
      <div class="details-box-body">
        <p>
          <span class="key">Counterparty</span>
          <span class="value">{{(bankTransactionsService.transactionDetailsObservable$| async)?.counterpartName ||
            '-'}}</span>
        </p>
        <p>
          <span class="key">Bank Account</span>
          <span class="value">
            {{(bankTransactionsService.transactionDetailsObservable$| async)?.counterpartReference || '-'}}
          </span>
        </p>
        <!-- <p>
          <span class="key">BIC</span>
          <span class="value">{{(bankTransactionsService.transactionDetailsObservable$| async)?.paymentPartner?.bic ||
            '-'}}</span>
        </p> -->
        <p>
          <span class="key">Creditor ID</span>
          <span class="value">{{(bankTransactionsService.transactionDetailsObservable$|
            async)?.creditorId || '-'}}</span>
        </p>
      </div>
    </div>
    <!-- <div class="details-box">
      <div class="details-header">
        <button class="icon-circle">
          <img src="../../../../assets/images/shared_icon.svg" height="17px" width="17px" alt="unlink" />
        </button>
        <span class="view-transaction-txt">Link invoice/receipt</span>
        <button class="link-btn" type="button" [ngClass]="{'link-btn-color' : !hideUnlink}" (click)="hideUnlink ? unlinkDialog() : attachmentPopup(false, false)">
          <ng-container *ngIf="hideUnlink; else linkImg">
            <img src="../../../../assets/images/unlink_icon.svg" height="20px" width="20px" alt="unlink" />
          </ng-container>
          <ng-template #linkImg>
            <img src="../../../../assets/images/attach_black_icon.svg" height="20px" width="20px" alt="Attach" />
          </ng-template>
          <span class="unlink-btn-text">{{hideUnlink ? 'Unlink' : 'Attach'}}</span>
        </button>
      </div>
      <ng-container  *ngIf="hideUnlink">
        <div class="unlink-container">
          <div class="unlink-file-list">
            <div class="file-icon">
              <img src="../../../../assets/images/document_icon.svg" alt="sync">
            </div>
            <div class="file-name">{{unlinkData?.invoiceNumber || '-'}}</div>
            <img class="view-icon" src="../../../../assets/images/eye_icon.svg" height="20px" width="20px" alt="view" (click)="attachmentPopup(true, true)">
          </div>
        </div>
      </ng-container>
    </div> -->
  </div>
</div>